import { render, staticRenderFns } from "./DetailsAccount.vue?vue&type=template&id=0c909dcc"
import script from "./DetailsAccount.vue?vue&type=script&lang=js"
export * from "./DetailsAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports